import React, { memo } from 'react';
import styled from 'styled-components';

import OnDemandIcon from 'assets/v2/OnDemandIcon';
import { COLORS } from 'theme';
import { BOOKING_TYPE_TIME_LABELS } from 'utils/constants';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.majorelleBlueDark};
    background: ${COLORS.majorelleBlueLight};
    border-color: ${COLORS.majorelleBlue};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.majorelleBlue};
    }
  }
`;

function OnDemandBookingTypeTag(props) {
  return (
    <StyledTag
      label={BOOKING_TYPE_TIME_LABELS.ONDEMAND}
      icon={<OnDemandIcon />}
      {...props}
    />
  );
}

export default memo(OnDemandBookingTypeTag);
